import styled from "styled-components";

export const HeaderLote = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
`;

export const AcoesLote = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;

  svg {
    margin-right: 6px;
  }
`;
